// The clock face, and the sweep that lights it.
//
// The 60 ticks are drawn here rather than shipped as markup: they are six
// attributes each and carry no meaning a reader or a crawler wants. What is in
// the markup is the six milestones, which are content.
(function () {
  if (window.__pruvitTimeline) return;
  window.__pruvitTimeline = true;

  var NS = 'http://www.w3.org/2000/svg';
  var CX = 300;
  var CY = 300;
  var R = 268;
  var TOTAL = 60;
  var STEP = 43; // ms between ticks; 60 × 43 ≈ the 2.6s sweep
  // Two, three and four o'clock, then eight, nine and ten — the six that sit
  // clear of the film in the middle.
  var KEY = [10, 15, 20, 40, 45, 50];

  function drawFace(gauge) {
    for (var i = 0; i < TOTAL; i++) {
      var isKey = KEY.indexOf(i) !== -1;
      var line = document.createElementNS(NS, 'line');
      line.setAttribute('x1', CX);
      line.setAttribute('y1', CY - R);
      line.setAttribute('x2', CX);
      line.setAttribute('y2', CY - R + (isKey ? 34 : 20));
      line.setAttribute('transform', 'rotate(' + (360 / TOTAL) * i + ' ' + CX + ' ' + CY + ')');
      line.setAttribute('class', isKey ? 'pruvit-clock__tick pruvit-clock__tick--key' : 'pruvit-clock__tick');
      line.style.transitionDelay = i * STEP + 'ms';
      gauge.appendChild(line);
    }
  }

  function start(clock) {
    if (clock.dataset.pruvitClockReady) return;
    clock.dataset.pruvitClockReady = 'true';

    var gauge = clock.querySelector('[data-pruvit-clock-gauge]');
    if (gauge && !gauge.firstChild) drawFace(gauge);

    // Only now do the milestones agree to start hidden: until this class
    // lands they are plain visible content, so a script that never runs costs
    // the reader nothing.
    clock.classList.add('pruvit-clock--animate');

    var reveal = function () {
      clock.classList.add('is-drawn');
      if (gauge) {
        gauge.querySelectorAll('.pruvit-clock__tick').forEach(function (tick) {
          tick.classList.add('is-lit');
        });
      }
    };

    if (!('IntersectionObserver' in window)) {
      reveal();
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          reveal();
          observer.disconnect();
        });
      },
      { threshold: 0.3 }
    );
    observer.observe(clock);
  }

  function init() {
    document.querySelectorAll('[data-pruvit-clock]').forEach(start);
  }

  init();
  // The theme editor rebuilds a section in place, which leaves a fresh clock
  // with no face drawn and no observer on it.
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', init);
})();
